define.alias("ember-math-helpers/helpers/sum", "calendar/helpers/sum");